// Thin wrapper around localStorage so we can swap it out later (e.g. for
// encrypted storage, IndexedDB) without hunting through the codebase.

const K_ACCESS = 'pm.clinic.access_token';
const K_REFRESH = 'pm.clinic.refresh_token';
const K_DEVICE_UUID = 'pm.clinic.device_uuid';

export function getAccessToken(): string | null {
    return localStorage.getItem(K_ACCESS);
}
export function setAccessToken(t: string | null): void {
    if (t) localStorage.setItem(K_ACCESS, t);
    else localStorage.removeItem(K_ACCESS);
}

export function getRefreshToken(): string | null {
    return localStorage.getItem(K_REFRESH);
}
export function setRefreshToken(t: string | null): void {
    if (t) localStorage.setItem(K_REFRESH, t);
    else localStorage.removeItem(K_REFRESH);
}

// Generated once per browser install, persisted forever, sent to the API on
// OTP verify so we can associate future sessions with the same "device".
// Mirrors the mobile app's device_uuid field on clinician_devices.
export function getOrCreateDeviceUuid(): string {
    const existing = localStorage.getItem(K_DEVICE_UUID);
    if (existing) return existing;
    const fresh = crypto.randomUUID();
    localStorage.setItem(K_DEVICE_UUID, fresh);
    return fresh;
}

export function clearSession(): void {
    setAccessToken(null);
    setRefreshToken(null);
    // Intentionally keep device_uuid across logouts — same device.
}
